import React from 'react';
import BannerOdd from './BannerOdd';

function BannerOddsOverlay(props) {
    const match = props.banner.avvData;
    const bet = match && match.bet;

    if(!match || !bet) {
        return <></>;
    }

    const desc = match.desc;
    let odds = bet.odds;
    if (odds.length > 4) {
        odds = odds.slice(0, 4);
    }
    return (
        <div className="banner-overlay">
            <div className="banner-overlay-text-container">
                <p className="banner-overlay-title">{desc}</p>
                <p className="banner-overlay-desc">{props.banner.text.length > 0 ? props.banner.text : bet.desc}</p>
            </div>
            <div className="banner-overlay-odds-container">
                {odds.map(odd =>
                    <BannerOdd key={odd.id} {...odd} />
                )}
            </div>
        </div>
    )
}

export default BannerOddsOverlay;